/**
 * useAnalytics — thin wrapper around GA4 gtag.
 * Fires page_view on route change and exposes trackEvent for custom events.
 * Safe to call when GA4 is not loaded (e.g. ad blockers, dev without ID).
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

function gtag(...args: unknown[]) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

export function trackPageView(path: string, title: string) {
  gtag("event", "page_view", {
    page_location: `https://www.pfasfireclaim.com${path}`,
    page_title: title,
  });
}

export function trackEvent(
  eventName: string,
  params?: Record<string, string | number | boolean>
) {
  gtag("event", eventName, params ?? {});
}

/**
 * Convenience wrappers for the key conversion events on this site.
 */
export const GA4 = {
  /** User clicked any primary CTA button */
  ctaClick: (label: string, location: string) =>
    trackEvent("cta_click", { cta_label: label, cta_location: location }),

  /** User advanced from Step 1 to Step 2 of the intake form */
  formStart: (source: "home" | "contact") =>
    trackEvent("form_start", { form_source: source }),

  /** User successfully submitted the intake form */
  formComplete: (source: "home" | "contact") =>
    trackEvent("form_complete", { form_source: source }),

  /** Generic event passthrough */
  event: (name: string, params?: Record<string, string | number | boolean>) =>
    trackEvent(name, params),
};
